import React, { useState } from "react";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    Typography,
    IconButton,
    Tooltip,
    InputAdornment,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import CopyToClipboard from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { apiGatewayAxiosInstance } from "../../../../utils/axios";
import { setErrorMessageForUser } from "../../../../redux/userManagement/userManagementSlice";
import { useDispatch } from "react-redux";
// email, setEmail, username, setUsername, password, setPassword

function EditEmailModal({ open, handleClose, modelOkClick }) {
    const [copySuccess, setCopySuccess] = useState(false);
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleCopyPassword = () => {
        setCopySuccess(true);
        setTimeout(() => {
            setCopySuccess(false);
        }, 2000);
    };

    const handleGeneratePassword = async () => {
        try {
            const response = await apiGatewayAxiosInstance.post("/user_management/clients/generate-password");
            const generatedPassword = response.data.password;
            setPassword(generatedPassword);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = error.response.data?.message || errorMessage;
            }

            dispatch(
                setErrorMessageForUser({
                    fieldName: "getClientEditDetailsErrorMessages",
                    errorMessage,
                }),
            );
        }
    };

    const handleEmail = e => {
        setEmail(e.target.value);
    };

    const handleUsername = e => {
        setUsername(e.target.value);
    };

    const handleOnClick = () => {
        modelOkClick(email, password, username);
        handleClose();
    };

    return (
        <React.Fragment>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h5">Edit Email</Typography>
                    <IconButton onClick={handleClose}>
                        <CloseOutlined />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent
                    sx={{
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        width: "500px",
                    }}
                >
                    <TextField
                        name="email"
                        fullWidth
                        label={"Reseller Admin Email"}
                        variant="outlined"
                        // className="field-spacing"
                        value={email}
                        onChange={handleEmail}
                    />
                    <TextField
                        name="username"
                        disabled={true}
                        fullWidth
                        label={
                            <span>
                                New Username <span style={{ color: "red" }}>*</span>
                            </span>
                        }
                        variant="outlined"
                        className="field-spacing"
                        value={email}
                    // onChange={handleUsername}
                    />

                    <Grid gap={4} display={"flex"} alignItems={"center"}>
                        <TextField
                            name="generatePassword"
                            id="generate-password"
                            label={
                                <span>
                                    Generate Password <span style={{ color: "red" }}>*</span>
                                </span>
                            }
                            variant="outlined"
                            className="field-spacing"
                            value={password}
                            disabled
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {password && (
                                            <CopyToClipboard text={password} onCopy={handleCopyPassword}>
                                                <Tooltip title={copySuccess ? "Copied!" : "Copy to clipboard"}>
                                                    <IconButton color="primary" size="small">
                                                        <ContentCopyIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </CopyToClipboard>
                                        )}
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button variant="contained" onClick={handleGeneratePassword} color="primary" size="small" width={"100%"}>
                            Generate Password
                        </Button>
                    </Grid>
                </DialogContent>

                <DialogActions
                    style={{
                        padding: "1rem 1.5rem",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: ".25rem",
                    }}
                >
                    <Button variant="contained" color="primary" autoFocus onClick={handleOnClick}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default EditEmailModal;
